var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.rules.length > 0
    ? _c(
        "div",
        _vm._l(_vm.rules, function (itemData) {
          return _c(
            "div",
            { staticClass: "link" },
            [
              _c(
                "el-link",
                {
                  attrs: {
                    href: itemData.href,
                    target: "_blank",
                    type: "primary",
                  },
                },
                [_vm._v(_vm._s(itemData.name))]
              ),
              _c("br"),
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }